import { render, staticRenderFns } from "./languageSettings.vue?vue&type=template&id=9813379e&scoped=true"
import script from "./languageSettings.vue?vue&type=script&lang=js"
export * from "./languageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9813379e",
  null
  
)

export default component.exports